import type { AdPlacement } from "@serendiptv/contracts";
export type AdSize = { width: number; height: number };
export function placementSize(placement: AdPlacement, width: number, height: number, occupied = 0): AdSize | null {
  if (placement === "cabinet") return width >= 300 && height - occupied >= 390 ? { width: 300, height: 100 } : null;
  // Masthead/columns/footer retain 54%; leave three readable 48px rows.
  if (width >= 760 && height * .46 >= 144 + 126) return { width: 728, height: 90 };
  if (width >= 352 && height * .46 >= 144 + 86) return { width: 320, height: 50 };
  return null;
}
export function fits(size: AdSize, available: AdSize | null) {
  return Boolean(available && size.width <= available.width && size.height <= available.height);
}
